import type { ProfilesStateType } from "../types/state";

const INITIAL_PROFILES_STATE: ProfilesStateType = {
    areProfilesFetching: false,
    isProfileCreating: false,
    isProfileDeleting: false,
    isProfileUpdating: false,
    isProfileExcluding: false,
    profileCreateError: undefined,
    profileDeleteError: undefined,
    profileUpdateError: undefined,
    profileExcludeError: undefined,
    profilesResult: {
        profiles: [],
        totalCount: 0,
    },
    profilesFetchError: undefined,
};

export default INITIAL_PROFILES_STATE;
